<template>
 <div style="height: 100vh;display: flex;align-items: center;justify-content: center;font-size: clamp(18px,3vw,50px);font-weight: 500">{{message}}</div>
</template>

<script>
export default {
  name: 'Page404',
  computed: {
    message() {
      return '对不起，找不到该页面'
    }
  }
}
</script>

<style scoped>

</style>
